/** VIA ServiceNow catalog item for Unity access (IQVIACBEXU-9883). */
export const UNITY_ACCESS = {
  VIA_TICKET_URL:
    "https://quintilestest.service-now.com/via?id=sc_cat_item&sys_id=18a99a939f1f0390660e02cb3124ab28",
};
